import { render, staticRenderFns } from "./EmployeeDetailView.vue?vue&type=template&id=6fbae5dd&scoped=true&"
import script from "./EmployeeDetailView.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailView.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetailView.vue?vue&type=style&index=0&id=6fbae5dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbae5dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
